import React, {useEffect, useState} from 'react'
import {useQuery} from "react-query";

import GiftToFriend from '../../../components/common/gifttoFriend';
import { useLocation, useParams } from 'react-router-dom';

import { useNavigate } from "react-router-dom";
import ErrorMessage from '../../../components/messaging/errormessage';
import CardsComponent from '../../common/cards'
import Loadingcomponent from '../../loader/loadingcomponent';
import { t } from 'i18next';
import OfferDetail from '../../loader/skeletons/common/offer-detail';

function ProductCardDetails() {
  const { offerId } = useParams();
  const {state} = useLocation();
  const [clickedOffer, setClickedOffer] = useState();
  const [otherOffer, setOtherOffersList] = useState();
  const navigate = useNavigate();
  const {data: {data}={}, isLoading, isFetching, error, isError, isLoadingError} = 
    useQuery([
      {}, 
      state?.psmItem ? state?.psmItem?.method : '/v6/api/subscription/discoveruserofffersV2', 
      state?.psmItem? JSON.parse(state?.psmItem?.sourceid) : JSON.parse(state?.sourceId) , 
      {}])

  useEffect(()=>{
    if(data?.response?.length > 0){
      setClickedOffer(data?.response?.filter(item => item?.offerid === offerId)[0]);
      let selectedType = data?.response?.filter(item => item?.offerid === offerId)[0]?.rnadditionalSubGroup;
      setOtherOffersList(data?.response?.filter(item => item?.rnadditionalSubGroup ===  selectedType && item?.offerid !== offerId))
    }
  }, [data, offerId])

  if(error || isLoadingError ||isError){
    return(
      <ErrorMessage message={data?.message || t("somethingwentwrong")}/>
    )
  }

  const handleViewDealClick = (offer) =>{
     navigate(`/roaming_product_details/${offer?.offerid}`, {
      state: { psmItem: state?.psmItem, sourceId: state?.sourceId },
    })
  }

  return (
    isLoading || isFetching ? <OfferDetail bannerHeight='190px' longOfferCard={true} /> : 
    <div >

           <div
            class="text-center sprint14_banner_bg"
            style={{ backgroundColor: '#F0F0F0' }}
          >
            <div >
              <img src={clickedOffer?.imageurl} alt="" title="" className='d-flex mb-3' width={123} />
            </div>
          </div>
      
      {clickedOffer && 
      <div className='pse_sm'>
        <div className="buy_card flex_grp_align_center">
          <div className="buy_card_info flex_grp_align_center flex1">
            <h3 className="section_title primary_color mb-0">
              {clickedOffer?.currency || ''}{' '}
              {clickedOffer?.amount || clickedOffer?.offerbaseprice || ''}
            </h3>
          </div>
          <div className="buy_card_action">
            <button className="custom_btn custom_btn_primary" 
              onClick={(e)=>{
                e.preventDefault();
                navigate('/pay', { state: { paytype: 'roamingdeals', offerData: clickedOffer }})
              }}
            >
              {clickedOffer?.action_button_text || clickedOffer?.actiontext}
            </button>
          </div>
          {clickedOffer?.isgiftenabled === 'T' && ((clickedOffer?.amount || clickedOffer?.offerbaseprice) > 0) && (
          <GiftToFriend data={clickedOffer} />
          )}
        </div>
        </div>
      }
    <div className="pse_sm">
      <h3 className="section_title mb-4">{clickedOffer?.title}</h3>
      <h5 className="primary_14 mb-2">{clickedOffer?.description_label}</h5>
      <p className="dark_gray_color mb-3">{clickedOffer?.description}</p>
      </div>
       {otherOffer?.length > 0 && state?.flag !== true && (
        <div className='pse_sm'>
          <hr className="hr_line"></hr>
          <h3 className="section_title_light mb-4 mt-4">{t('umaylike')}</h3>

          {otherOffer?.slice(0,3)?.map((offer) => {
            return (
              <div className="mb-3">
                <div className="card_style_2 pointer height_100" onClick={()=>handleViewDealClick(offer)}>
                <div className="card_img">
                    <img src={offer?.imageurl || process.env.PUBLIC_URL + '/assets/images/b-5g.svg'} alt="" title="" />
                </div>
                <div className="card_info">
                    <div className="card_info_grp">
                        <h4>{offer?.title}</h4>
                        <p>{offer?.description}</p>
                    </div>
                    <div className="card_link flex_grp_align_center">
                        <div className="hyperlink">
                            {offer?.currency} {offer?.offerdiscountprice || offer?.offerbaseprice || ''}
                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                        </div>
                    </div>
                </div>
            </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  )
}

export default ProductCardDetails
